// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1A3ww","buttons":"Footer_buttons__1OXqj"};